import axios from './index'
import qs from 'qs';
class game{
    static activityInfo(options) {
        return axios.get('/nice-api-customer/v1/clipRedPacketActivity/enabledActivity', {params:options})
    }
    static searchRecord(options) {
        return axios.get(`/nice-api-customer/v1/clipRedPacketActivity/${options.id}/searchRecord`)
    }
    static successGame(options) {
        return axios.post('/nice-api-customer/v1/clipRedPacketActivity/successGame', options)
    }
    static playCount(options) {
        return axios.patch(`/nice-api-customer/v1/clipRedPacketActivity/${options.id}/playCount?${qs.stringify(options)}`,{params:options})
    }
    
}

export default game;
